import React from 'react';
import { useSwiperSlide } from 'swiper/react';
import { enhancedConnect } from "../../../utils";
var _CarouselDiv = function _CarouselDiv(_ref) {
  var children = _ref.children,
    style = _ref.style,
    styleActive = _ref.styleActive;
  var swiperSlide = useSwiperSlide();
  var isActive = swiperSlide.isActive;
  return /*#__PURE__*/React.createElement("div", {
    style: isActive ? styleActive : style,
    "data-t-id": "Carousel-CarouselDiv"
  }, children);
};
export var CarouselDiv = enhancedConnect()(_CarouselDiv);